import Link from 'next/link';

const GalleryAd = props => {
  const { item } = props;

  return (
    <Link
      className='w-full cursor-pointer overflow-hidden rounded-[10px] lg_rounded-none'
      href={item.link}
      aria-label={item.title}
    >
      <picture>
        <source
          media='(max-width: 959px)'
          srcSet={item.m_img}
        />
        <source
          media='(min-width: 960px)'
          srcSet={item.img}
        />
        <img
          alt=''
          className='block h-full w-full object-cover'
        />
      </picture>
    </Link>
  );
};

export default GalleryAd;
